import { Icon } from '@iconify/react';
import FormSection from './FormSection';
import VisitorAvatar from '../VisitorAvatar';
import SearchableDropdown from '../../../../../components/SearchableDropdown';
import { labelCls, errorCls, controlCls } from './formStyles';
import { VISITOR_TYPES, VISITOR_TYPE_ICON, LIMITS, typeLabel } from '../../visitorConstants';

const TYPE_OPTIONS = VISITOR_TYPES.map(t => ({ value: t, label: typeLabel(t) }));

const IdentityFields = ({ form, errors, set }) => (
    <FormSection
        icon="mdi:account-outline"
        title="Who is visiting"
        hint="The phone number identifies this person for every future visit"
    >
        <div className="tw-flex tw-items-start tw-gap-4">
            {/* Live preview of the row the gate will see. Hidden on narrow
                screens where the fields need the full width. */}
            <div className="tw-hidden sm:tw-flex tw-flex-col tw-items-center tw-gap-1.5 tw-pt-1">
                <VisitorAvatar
                    visitor={{ name: form.name, photo_url: form.photo_url, visitor_type: form.visitor_type }}
                    size={64}
                />
                <span className="tw-text-[9px] tw-text-gray-400">Preview</span>
            </div>

            <div className="tw-flex-1 tw-space-y-3">
                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3">
                    <div className="sm:tw-col-span-2">
                        <label className={labelCls}>Full name <span className="tw-text-rose-500">*</span></label>
                        <input
                            type="text"
                            value={form.name}
                            onChange={e => set('name', e.target.value)}
                            maxLength={LIMITS.name}
                            placeholder="e.g. Rajesh Kumar"
                            className={controlCls(!!errors.name)}
                        />
                        {errors.name && <p className={errorCls}>{errors.name}</p>}
                    </div>
                    <div>
                        <label className={labelCls}>Visitor type <span className="tw-text-rose-500">*</span></label>
                        {/* clearable is off deliberately: the component's clear
                            button calls onChange('all'), a sentinel meant for
                            filter dropdowns. Visitor type is required and always
                            has a value, so there is nothing to clear to — and
                            'all' would reach the API as an invalid enum. */}
                        <SearchableDropdown
                            small
                            clearable={false}
                            value={form.visitor_type}
                            onChange={(v) => set('visitor_type', v)}
                            options={TYPE_OPTIONS}
                            placeholder="Select type"
                        />
                    </div>
                </div>

                {/* Type is the field the gate reads first, so it also gets a
                    one-click row rather than living only inside the select. */}
                <div className="tw-flex tw-flex-wrap tw-gap-1.5">
                    {VISITOR_TYPES.map(t => (
                        <button
                            key={t}
                            type="button"
                            onClick={() => set('visitor_type', t)}
                            className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2.5 tw-py-1 tw-rounded-full tw-text-[10px] tw-font-medium tw-border tw-transition-colors ${form.visitor_type === t
                                ? 'tw-bg-sky-600 tw-text-white tw-border-sky-600'
                                : 'tw-bg-white tw-text-gray-600 tw-border-gray-200 hover:tw-bg-gray-50'
                                }`}
                        >
                            <Icon icon={VISITOR_TYPE_ICON[t]} className="tw-text-xs" />
                            {typeLabel(t)}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    </FormSection>
);

export default IdentityFields;
